import React from 'react'

function ZenModeIcon({
  className,
  onClick,
}: {
  className: string
  onClick: () => void
}): JSX.Element {
  return (
    <svg
      width="46"
      height="46"
      viewBox="0 0 54 54"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      onClick={onClick}
    >
      <rect
        y="0.121582"
        width="53.7568"
        height="53.7568"
        rx="26.8784"
        fill="white"
      />
      <path
        d="M44.9792 22.7191C42.9099 22.7357 40.8259 22.8073 38.8393 23.0518V15.9801L37.6246 16.2301C37.4886 16.2576 34.4839 16.9082 30.9058 20.0232C30.031 18.6173 28.967 17.114 27.6787 15.438L26.8775 14.3942L26.0762 15.438C24.788 17.114 23.7239 18.6191 22.8491 20.0232C19.2729 16.91 16.2682 16.2595 16.1322 16.2301L14.9175 15.9801V23.0499C12.9327 22.8073 10.8469 22.7338 8.77756 22.7173L7.57751 22.7099L7.77232 23.8934C8.7408 29.7871 10.8983 33.9624 14.3661 36.6584C17.2606 38.9096 21.0335 40.0766 25.8741 40.2163V40.231H26.872H26.8848H27.8827V40.2163C32.7233 40.0766 36.4962 38.9096 39.3907 36.6584C42.8585 33.9624 45.016 29.7871 45.9845 23.8934L46.1793 22.7099L44.9792 22.7191ZM36.8178 18.6265V23.3697C35.5222 23.6251 34.2909 23.9798 33.1607 24.4687C32.8318 23.5994 32.4275 22.7191 31.9405 21.8076C33.9068 20.0342 35.695 19.0933 36.8178 18.6265ZM27.9121 38.1176C28.1198 31.2463 30.2699 28.7396 31.9662 27.4679C32.2694 28.8517 32.3668 30.2043 32.3668 31.6781C32.3668 34.5211 30.9646 37.5607 27.9121 38.1176ZM26.8775 17.7297C29.2041 20.8667 30.5768 23.2613 31.3671 25.4225C31.2072 25.5254 31.0491 25.632 30.8948 25.7441C29.0184 27.1077 27.6934 29.0079 26.8756 31.5476C26.0578 29.0079 24.7328 27.1058 22.8565 25.7441C22.7021 25.632 22.5441 25.5272 22.3842 25.4225C23.1799 23.2631 24.5527 20.8685 26.8775 17.7297ZM21.39 31.6781C21.39 30.2043 21.4874 28.8517 21.7906 27.4679C23.485 28.7396 25.637 31.2463 25.8447 38.1176C22.7922 37.5607 21.39 34.5211 21.39 31.6781ZM16.939 18.621C18.0563 19.0822 19.8353 20.0177 21.8163 21.8076C21.3293 22.7191 20.925 23.5994 20.5961 24.4687C19.4659 23.9798 18.2346 23.6251 16.939 23.3697V18.621ZM9.98496 24.759C14.6142 24.8638 17.7218 25.3655 19.9823 26.4001C19.5504 28.0743 19.3666 29.7797 19.3666 31.6763C19.3666 33.9 20.0245 35.9748 21.2191 37.5148C21.2558 37.5607 21.2944 37.6048 21.3312 37.6508C15.0681 36.2412 11.4699 32.1045 9.98496 24.759ZM32.4238 37.6526C32.4605 37.6067 32.4991 37.5626 32.5359 37.5166C33.7304 35.9766 34.3883 33.9018 34.3883 31.6781C34.3883 29.7797 34.2045 28.0761 33.7727 26.402C36.0331 25.3673 39.1426 24.8656 43.77 24.7609C42.2851 32.1045 38.6886 36.2412 32.4238 37.6526Z"
        fill="black"
      />
    </svg>
  )
}

export default React.memo(ZenModeIcon)